module.exports = __webpack_public_path__ + "img/syndicate.cfa76b17.png";